// extracted by mini-css-extract-plugin
module.exports = {"pageHead":"TournamentRules_pageHead__hm0Cf","pageContent":"TournamentRules_pageContent__3Spop"};